import { render, staticRenderFns } from "./AssignManager.vue?vue&type=template&id=bc27c87a&scoped=true"
import script from "./AssignManager.vue?vue&type=script&lang=js"
export * from "./AssignManager.vue?vue&type=script&lang=js"
import style0 from "./AssignManager.vue?vue&type=style&index=0&id=bc27c87a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc27c87a",
  null
  
)

export default component.exports